module.exports = __webpack_public_path__ + "Stronger-6f859289.png";